function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import View from "../View";
/**
 * A FlexView component combine View and Flex components. That means it
 * defines the position for its child components but also creates a flex
 * container of the wrapping element.
 */

export var FlexView = function FlexView(_ref) {
  var children = _ref.children,
      style = _ref.style,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      onClick = _ref.onClick;
  var styles = {
    "default": {
      height: '100%',
      width: '100%',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    }
  };

  var outputStyles = _objectSpread(_objectSpread({}, styles["default"]), style);

  if (outputStyles.width === '100%') {
    outputStyles = _objectSpread(_objectSpread({}, outputStyles), {
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: 0,
      marginRight: 0
    });
  }

  if (outputStyles.height === '100%') {
    outputStyles = _objectSpread(_objectSpread({}, outputStyles), {
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0
    });
  }

  var addOnClick = {};

  if (typeof onClick === 'function') {
    addOnClick = {
      onClick: onClick
    };
  }

  return /*#__PURE__*/React.createElement(View, _extends({
    tagName: tagName,
    style: outputStyles
  }, addOnClick), children);
};
FlexView.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string, PropTypes.number]),

  /**
   * Override or extend the default styles. If you want to use
   * paddingLeft/Right or marginLeft/Right set width to 'unset'.
   * The same to height if you want using paddingTop/Bottom or
   * marginTop/Bottom.
   */
  style: PropTypes.object,

  /**
   * Type of HTML-tag output.
   */
  tagName: PropTypes.string,

  /**
   * Handle click.
   */
  onClick: PropTypes.func
} : {};
export default FlexView;
//# sourceMappingURL=FlexView.js.map